import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import AuxiliaryService from '../entities/flight/auxiliaryService'


interface AuxiliaryServiceState extends ListState<AuxiliaryService> {
    auxiliaryService: AuxiliaryService,
    editAuxiliaryService: AuxiliaryService,


}

class AuxiliaryServiceMutations extends ListMutations<AuxiliaryService>{

}

class AuxiliaryServiceModule extends ListModule<AuxiliaryServiceState, any, AuxiliaryService>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<AuxiliaryService>(),
        loading: false,
        editAuxiliaryService: new AuxiliaryService(),
        selectAuxiliaryService: new AuxiliaryService(),


    }
    actions = {



        async saveAuxiliaryService(context: ActionContext<AuxiliaryServiceState, any>, payload: any) {
            let reponse = await Ajax.post(
                '/api/services/app/Flight/SaveAuxiliaryService',
                payload.data
            );

            let page = reponse.data.result as PageResult<AuxiliaryService>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;


        },


        async getAuxiliaryServices(context: ActionContext<AuxiliaryServiceState, any>, payload: any) {

            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Flight/GetAuxiliaryServices', payload.data);
            console.log(reponse);
            context.state.loading = false;
            let page = reponse.data.result as PageResult<AuxiliaryService>;

            context.state.totalCount = page.totalCount;
            context.state.list = page.items;


        },




    };
    mutations = {
        setCurrentPage(state: AuxiliaryServiceState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: AuxiliaryServiceState, pagesize: number) {
            state.pageSize = pagesize;
        },

    }
}
const auxiliaryServiceModule = new AuxiliaryServiceModule();
export default auxiliaryServiceModule;